// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.text.secondary,
          '&.Mui-focused': {
            color: theme.vars.palette.primary.main
          },
          '&.Mui-error': {
            color: theme.vars.palette.error.main
          }
        },
        outlined: {
          '&.MuiInputLabel-shrink': {
            zIndex: 1,
            backgroundColor: theme.vars.palette.background.paper
          }
        }
      }
    }
  };
}
